export const path = "/creacion-de-conversiones";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "CREAR CONVERSIONES",
  section: "ALUNA",
  group: "CSM",
  order: 5,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
  ],
};
